import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore"; // ← changed
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCGh_MaBmOXKDiVsceicVRklB0a80dZjWc",
  authDomain: "tennant-tours.firebaseapp.com",
  databaseURL: "https://tennant-tours-default-rtdb.firebaseio.com",
  projectId: "tennant-tours",
  storageBucket: "tennant-tours.firebasestorage.app",
  messagingSenderId: "585667862595",
  appId: "1:585667862595:web:19ed75e3c4e5bd332f34f6",
  measurementId: "G-YQWLCF0H0V"
};

const app = initializeApp(firebaseConfig);

export default app;
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: false,
  experimentalForceLongPolling: false,
});
export const database = getDatabase(app);